import type { ApiErrorBody } from '@gobingebox/shared';

/**
 * API base URL.
 *  • dev: "/api" → Vite proxy → Worker on :8787
 *  • prod: set VITE_API_URL to the Worker origin (e.g. https://api.gobingebox.com)
 */
export const API_BASE = import.meta.env.VITE_API_URL?.replace(/\/$/, '') || '/api';

export class ApiError extends Error {
  constructor(
    public status: number,
    public body: ApiErrorBody,
  ) {
    super(body.message ?? body.error ?? `Request failed (${status})`);
    this.name = 'ApiError';
  }
}

/** Typed fetch wrapper. Sends cookies (credentials) for session auth. */
export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    ...init,
    headers: {
      Accept: 'application/json',
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...init?.headers,
    },
  });

  const isJson = res.headers.get('content-type')?.includes('application/json');
  const data = isJson ? await res.json().catch(() => null) : null;

  if (!res.ok) {
    throw new ApiError(res.status, (data as ApiErrorBody) ?? { error: 'request_failed' });
  }
  return data as T;
}
